export default {"src":"/_next/static/media/fav-add.73876466.svg","height":14,"width":14};